import React, { Component } from 'react'
import { fromJS } from 'immutable'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar'
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'

import PresetItem from './preset-item'

class Presets extends Component {

  _loadPreset = (id) => {
    const { dispatch, __items } = this.props
    dispatch(actions.change('paymentState.fees', fromJS([])))
    __items.get(id.toString()).map((item) => {
      dispatch(actions.push('paymentState.fees', fromJS({
        id: 0,
        fee_id: item.get('fee_id'),
        fee_code: item.get('fee_code'),
        fee_name: item.get('fee_name'),
        acct_code: item.get('acct_code'),
        amount: item.get('amount').toString(),
      })))
      return true
    })
  }

  render() {
    const { __list } = this.props
    return (
      <ButtonToolbar>
        <ButtonGroup style={{float: 'right'}}>
          {__list.map((item, k) => (
            <PresetItem
              key={k}
              k={k}
              item={item}
              onClick={this._loadPreset}
            />
          ))}
        </ButtonGroup>
      </ButtonToolbar>
    )
  }
}

function mapStateToProps(state) {
  return {
    __list: state.preset.get('list'),
    __items: state.preset.get('items'),
  }
}

export default connect(mapStateToProps)(Presets)



// WEBPACK FOOTER //
// ./src/containers/Payments/presets.js